import { useAtomValue } from 'jotai';
import { useEffect } from 'react';

import { patientConsentAtom } from '../../session/messages/state';
import { toast } from '../../toasts';
import { ConsentStatus, roomAtom } from '../../video-sdk';
import { RequestingClientConsentToast } from './RequestingClientConsentToast';

const REQUESTING_CONSENT_TOAST_KEY = 'requesting-client-consent-toast';

export function useRequestingClientConsentToast() {
  const room = useAtomValue(roomAtom);
  const patientConsent = useAtomValue(patientConsentAtom).value;
  const requestingClientConsent = patientConsent === ConsentStatus.DECIDING;

  useEffect(
    function clearToastOnRoomDisconnect() {
      // If the session ends, remove the toast.
      if (!room) {
        toast.close(REQUESTING_CONSENT_TOAST_KEY);
      }
    },
    [room],
  );

  useEffect(
    function syncRequestingConsentToast() {
      if (requestingClientConsent) {
        toast.enqueue(RequestingClientConsentToast, {
          key: REQUESTING_CONSENT_TOAST_KEY,
          timeout: Infinity,
        });
      } else if (!requestingClientConsent) {
        toast.close(REQUESTING_CONSENT_TOAST_KEY);
      }

      // Also clean up the toast on unmount, e.g. when the recording control is
      // unmounted because recording is no longer an option for the session.
      return () => {
        toast.close(REQUESTING_CONSENT_TOAST_KEY);
      };
    },
    [requestingClientConsent],
  );
}
